import Vue from "vue";
import VueRouter from "vue-router";

import store from "@/store";

import AddSample from "@/views/XRay/AddSample.vue";
import Loading from "@/views/Loading.vue";
import Menu from "@/views/XRay/Menu.vue";
import NotAllowed from "@/views/NotAllowed.vue";
import SetActiveService from "@/views/SetActiveService.vue";
import Signin from "@/views/Signin.vue";
import ViewSubmissions from "@/views/XRay/ViewSubmissions.vue";

Vue.use(VueRouter);

const guard = async (to, from, next) => {
  if (store.state.auth.loggedIn) {
    if (store.getters.isAllowed) {
      return next();
    } else {
      return next("/menu");
    }
  } else {
    return next("/signin");
  }
};

const routes = [
  {
    path: "/signin",
    name: "Signin",
    component: Signin
  },
  {
    path: "/loading",
    name: "Loading",
    component: Loading
  },
  {
    path: "/notallowed",
    name: "NotAllowed",
    component: NotAllowed
  },

  // guarded routes
  {
    path: "/addSample",
    name: "AddSample",
    component: AddSample,
    beforeEnter: guard
  },
  {
    path: "/menu",
    name: "Menu",
    component: Menu,
    beforeEnter: guard
  },
  {
    path: "/setActiveService",
    name: "SetActiveService",
    component: SetActiveService,
    beforeEnter: guard
  },
  {
    path: "/viewSubmissions",
    name: "ViewSubmissions",
    component: ViewSubmissions,
    beforeEnter: guard
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
